<section>
  <div class="mb-4 flex items-center justify-between">
    <div>
      <h1 class="text-2xl font-bold">UAC Actions</h1>
      <nav class="text-sm text-gray-600">
        <span>Dashboard</span> / <span>Main Menus</span> / <span>UAC Actions</span>
      </nav>
    </div>

    <div class="flex gap-2">
      <button class="btn btn-sm btn-ghost" type="button" (click)="backToMenus()">
        Back
      </button>
      <button class="btn btn-sm btn-primary" type="button" (click)="openCreate()">
        Create Action
      </button>
    </div>
  </div>

  <div class="card border rounded-lg shadow-sm">
    <div class="card-body p-0">
      <div *ngIf="editingAction" class="p-4">
        <h2 class="mb-3 text-lg font-semibold">
          {{ isCreate ? "Create Action" : "Edit Action" }}
        </h2>

        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="label">Main Menu</label>
            <select
              class="select select-bordered w-full"
              [(ngModel)]="editingAction.main_menu_id"
              (ngModelChange)="onMainMenuChange($event)"
            >
              <option [ngValue]="null">Select Menu</option>
              <option *ngFor="let node of allMenuNodes" [ngValue]="node.id">
                {{ node.depth > 0 ? ('— '.repeat(node.depth) + ' ') : '' }}{{ node.menu_name }}
              </option>
            </select>
          </div>

          <div>
            <label class="label">Name</label>
            <input
              class="input input-bordered w-full"
              [(ngModel)]="editingAction.name"
              name="name"
              required
             
              maxlength="50"
            />
          </div>

          <div>
            <label class="label">Slug</label>
            <input
              class="input input-bordered w-full"
              [(ngModel)]="editingAction.slug"
              name="slug"
              required
             
              maxlength="100"
            />
          </div>

          <div>
            <label class="label">Action URL</label>
            <input
              class="input input-bordered w-full"
              [(ngModel)]="editingAction.action_url"
              name="action_url"
              required
              minlength="1"
              maxlength="200"
            />
          </div>

          <div class="flex items-center gap-6 pt-8">
            <label class="flex items-center gap-2">
              <input
                type="checkbox"
                class="checkbox"
                [(ngModel)]="editingAction.is_active"
              />
              <span>Active</span>
            </label>
          </div>
        </div>

        <div class="mt-4 flex gap-2">
          <button class="btn btn-primary" type="button" (click)="saveAction()">
            Save
          </button>
          <button class="btn btn-ghost" type="button" (click)="cancelEdit()">
            Cancel
          </button>
        </div>
      </div>

      
    </div>
  </div>
</section>
